export default __webpack_public_path__ + "static/media/constructionManager.07cc95bd.png";